// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-pages-404-jsx": () => import("./../../../src/pages/404.jsx" /* webpackChunkName: "component---src-pages-404-jsx" */),
  "component---src-pages-directory-[merchant]-locations-tsx": () => import("./../../../src/pages/directory/[merchant]/locations.tsx" /* webpackChunkName: "component---src-pages-directory-[merchant]-locations-tsx" */),
  "component---src-pages-directory-[merchant]-tsx": () => import("./../../../src/pages/directory/[merchant].tsx" /* webpackChunkName: "component---src-pages-directory-[merchant]-tsx" */),
  "component---src-pages-directory-index-tsx": () => import("./../../../src/pages/directory/index.tsx" /* webpackChunkName: "component---src-pages-directory-index-tsx" */),
  "component---src-templates-legal-two-column-jsx": () => import("./../../../src/templates/legal-two-column.jsx" /* webpackChunkName: "component---src-templates-legal-two-column-jsx" */)
}

